<template>
<div>
	<!-- HEADING -->
	<div class="title has-text-centered mb-5">
		Achievement
		<button v-if="allow_editing" v-on:click="achievements.modals.achievement.show=true" class="button is-rounded is-primary p-4">
			<span class="icon">
				<i class="fa fa-plus"></i>
			</span>
		</button>
	</div>

	<FormErrors v-bind:errors="achievements.errors.detail" />


	<!-- achievement RECORDS -->
	<ul v-if="achievements.data.length === 0">
		<li class="box has-text-centered is-centered has-text-weight-bold has-background-white">
			No data
		</li>
	</ul>
	<ul v-else class="px-3" style="max-height: min(600px, 60vh); overflow-y: auto;">
		<li v-for="(achievement, index) in achievements.data" class="pb-5">
			<AchievementBox v-bind:is_editable="allow_editing"
						 v-bind:achievement=achievement
						 v-on:edit_achievement="edit_achievement(index)"
						 v-on:show_achievement_details="show_achievement_details(index)" />
		</li>
	</ul>


	<!-- VIEW PARTICULAR achievement DETAILS MODAL -->
	<div v-bind:class="{ 'is-active': achievements.modals.details.show }" class="modal">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">achievement details</p>
				<button v-on:click="achievements.modals.details.show=false" class="delete" aria-label="close"></button>
			</header>

			<div class="modal-card-body">
				<p class="content is-medium">{{ achievements.modals.details.content.details }}</p>
			</div>
		</div>
	</div>


	<!-- ADD/UPDATE achievement MODAL -->
	<div v-if="allow_editing" v-bind:class="{ 'is-active': achievements.modals.achievement.show }" class="modal">
		<div class="modal-background" v-on:click="clear_and_close_achievement_modal"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<span v-if="achievements.edit_index === -1" class="modal-card-title">Add Achievement</span>
				<span v-else class="modal-card-title">Edit Achievement</span>
				<button v-on:click="clear_and_close_achievement_modal" class="delete" aria-label="close"></button>
			</header>

			<section class="modal-card-body has-text-left">
				<InputBox input_type="text" v-model="achievements.modals.achievement.content.title"
						  v-bind:errors="achievements.modals.achievement.errors.title"
						  label="Title" icon="fas fa-heading" />

				<InputBox input_type="text" v-model="achievements.modals.achievement.content.associated_with"
						  v-bind:errors="achievements.modals.achievement.errors.associated_with"
						  label="Associated with" icon="fas fa-school" />

				<div class="columns pb-0">
					<div class="column">
						<InputBox input_type="month" v-model="achievements.modals.achievement.content.issue_date"
								  v-bind:errors="achievements.modals.achievement.errors.issue_date"
								  label="Issue Date" icon="fas fa-calendar" />
					</div>
				</div>

				<InputBox input_type="textarea" v-model="achievements.modals.achievement.content.details"
						  v-bind:errors="achievements.modals.achievement.errors.details"
						  label="Details" icon="fas fa-info-circle"/>

				<FormErrors v-bind:errors="achievements.modals.achievement.errors.detail" />
				<FormErrors v-bind:errors="achievements.modals.achievement.errors.non_field_errors" />
			</section>

			<footer class="modal-card-foot">
				<div class="columns is-mobile" style="width: 100%;">
					<div class="column is-narrow has-text-left">
						<button v-if="achievements.edit_index >= 0" v-on:click="delete_achievement" class="button is-danger">Delete</button>
					</div>

					<div class="column has-text-right">
						<button v-if="achievements.edit_index >= 0" v-on:click="update_achievement" class="button is-success">Update</button>
						<button v-else v-on:click="add_achievement" class="button is-success">Add</button>

						<button v-on:click="clear_and_close_achievement_modal" class="button">Cancel</button>
					</div>
				</div>
			</footer>
		</div>
	</div>
</div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import axios from "../../api/my-axios";
import AchievementBox from "./AchievementBox";
import InputBox from "../FormHelpers/InputBox";
import FormErrors from "../FormHelpers/FormErrors";

export default {
	components: {
		AchievementBox,
		InputBox,
		FormErrors
	},
	props: {
		is_editable: {
			type: Boolean,
			default: false
		},
		profile_uid: {
			type: String,
			default: null
		},
		 list_star: {
			type: Object,
			default: null
		},
		user_role: { // "mentor" or "mentee"
			type: String,
			default: null
		}
	},
	computed: {
		...mapState({
			user: "user"
		}),
		...mapGetters({
			role: "role" // "mentor" or "mentee"
		})
	},
	data() {
		return {
			allow_editing: false,
			to_show_user_role: this.user_role,
			to_show_profile_uid: this.profile_uid,

			achievements: {
				request_token: {
					// mentee: ""
				},

				errors: {},

				edit_index: -1,

				modals: {
					details: {
						show: false,
						content: {
							details: ""
						},
						errors: {}
					},

					achievement: {
						show: false,
						content: {
							title: "", // "" is important, as null=True is not allowed in back-end
							associated_with: "",
							issue_date: "",
							details: ""
						},
						errors: {}
					}
				},

				data: [
					// uid: "",
					// title: "", // "" is important, as null=True is not allowed in back-end
					// associated_with: "",
					// issue_date: "",
					// details: ""
				]
			}
		};
	},
	created()
	{
		this.to_show_profile_uid = this.profile_uid ? this.profile_uid : this.user.profile_uid;
		this.to_show_user_role = this.user_role ? this.user_role : this.role;
		this.allow_editing = this.is_editable ? (this.to_show_profile_uid === this.user.profile_uid) : false;

		this.achievements.request_token[this.role] = this.user.profile_uid;
		this.get_all_achievements();
	},
	methods: {
		clear_achievement_modal()
		{
			for (const key in this.achievements.modals.achievement.content) {
				this.achievements.modals.achievement.content[key] = "";
			}

			this.achievements.edit_index = -1; // Important
			this.achievements.modals.achievement.errors = {};
		},

		clear_and_close_achievement_modal()
		{
			this.clear_achievement_modal();
			this.achievements.modals.achievement.show = false;
		},

		show_achievement_details(index)
		{
			if (index >= this.achievements.data.length) { return; }
			this.achievements.modals.details.content.details = this.achievements.data[index].details;
			this.achievements.modals.details.show = true;
		},
 		get_all_achievements(){
            
            for( let uid_key in this.list_star.achievements){
                this.get_achievement(this.list_star.achievements[uid_key])

            }
        },
		get_achievement(key)
		{   
            
			axios
				.get(`/api/${this.to_show_user_role}/achievement/${key}/`)
				.then(response => {
                    let temp=response.data
					this.achievements.data.push(temp);
				})
				.catch(error => {
					this.achievements.errors = error.response ? error.response.data : {"detail": [error.message]};
				});
		},

		add_achievement()
		{
			if (!this.allow_editing) { return; }



			axios
				.post(`/api/${this.role}/achievement/`, {
					...this.achievements.modals.achievement.content,
					...this.achievements.request_token,
				})
				.then(_ => {
					this.get_achievements();
					this.clear_and_close_achievement_modal();
				})
				.catch(error => {
					this.achievements.modals.achievement.errors = error.response.data;
				});
		},

		edit_achievement(index)
		{
			if (!this.allow_editing) { return; }
			if (index < 0 || index >= this.achievements.data.length) { return; }

			this.achievements.edit_index = index;
			for (const key in this.achievements.modals.achievement.content) {
				this.achievements.modals.achievement.content[key] = this.achievements.data[this.achievements.edit_index][key];
			}

			this.achievements.modals.achievement.show = true;
		},

		update_achievement()
		{
			if (!this.allow_editing) { return; }
			if (this.achievements.edit_index < 0 || this.achievements.edit_index >= this.achievements.data.length) { return; }

			axios
				.put(`/api/${this.role}/achievement/${this.achievements.data[this.achievements.edit_index].uid}/`, {
					...this.achievements.modals.achievement.content,
					...this.achievements.request_token,
				})
				.then(_ => {
					this.get_achievements();
					this.clear_and_close_achievement_modal();
				})
				.catch(error => {
					this.achievements.modals.achievement.errors = error.response.data;
				});
		},

		delete_achievement()
		{
			if (!this.allow_editing) { return; }
			if (this.achievements.edit_index < 0 || this.achievements.edit_index >= this.achievements.data.length) { return; }

			axios
				.delete(`/api/${this.role}/achievement/${this.achievements.data[this.achievements.edit_index].uid}/`, {
					data: {
						...this.achievements.request_token
					}
				})
				.then(_ => { // No need to get achievements again as order remains unchanged
					this.achievements.data.splice(this.achievements.edit_index, 1);
					this.clear_and_close_achievement_modal();
				})
				.catch(error => {
					this.achievements.modals.achievement.errors = error.response.data;
				});
		}
	}
}
</script>
